
import { Loading, Notification } from 'element-ui'
import axios from 'axios'
import qs from 'qs'

// axios.interceptors.request.use(config => {
//   if (config.method == 'post') {
//     config.data = {
//       data: config.data,
//       _t: Date.parse(new Date().getTime()) / 1000
//     }
//   } else if (config.method == 'get') {
//     config.params = {
//       _t: Date.parse(new Date().getTime()) / 1000,
//       ...config.params
//     }
//   }
//   return config
// })

axios.interceptors.response.use(function(response) {
  if(response.data.status === false) {
    Notification.error({title: '错误', message: response.data.remark, duration: 3000})
  }
  // 对响应数据做点什么
  return response;
}, function(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';
        break;
      case 401:
        err.message = '未授权，请重新登录(401)';
        break;
      case 403:
        err.message = '拒绝访问(403)';
        break;
      case 404:
        err.message = '请求出错(404)';
        break;
      case 408:
        err.message = '请求超时(408)';
        break;
      case 500:
        err.message = '服务器错误(500)';
        break;
      case 501:
        err.message = '服务未实现(501)';
        break;
      case 502:
        err.message = '网络错误(502)';
        break;
      case 503:
        err.message = '服务不可用(503)';
        break;
      case 504:
        err.message = '网络超时(504)';
        break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';
        break;
      default:
        err.message = `连接出错(${err.response.status})!`;
    }
  } else {
    err.message = '连接服务器失败!'
  }
  Notification.error({title: '错误', message: err.message, duration: 0})
  return Promise.reject(err);
});

// 获取数据
export function getmediaInfo (params) {
  let loadingInstance = Loading.service({
    text: '加载中,请稍后...'
  })
  return axios.post(`/IAD_MediaCertificationReq/List?_t=${new Date().getTime()}`, params)
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}
// 媒体商审核
export function reviewMediaInfo (params) {
  let loadingInstance = Loading.service({
    text: '处理中,请稍后...'
  })
  return axios.post(`/IAD_MediaCertificationReq/Review?_t=${new Date().getTime()}`, params)
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}
// 导出媒体商审核信息
export function outPutMediaInfo (params) {
  return axios.post(`/IAD_MediaCertificationReq/ExportData?_t=${new Date().getTime()}`,params).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取广告列表
export function getAdList () {
  return axios.get(`/IAD_PutOnAPI/GetIADAdSelectList?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取投放形式列表
export function getPutonType () {
  return axios.get(`/IAD_PutOnAPI/GetPutOnTypeList?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取广告标签列表
export function getLabelList () {
  return axios.get(`/IAD_PutOnAPI/GetLabelList?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取地域列表
export function getAreaList () {
  return axios.get(`/IAD_PutOnAPI/GetAreaList?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取广告位列表
export function getMediaList (data) {
  return axios.post(`/Iad_CustomerTemplate/GetMediaList?_t=${new Date().getTime()}`, data).then(res => {
    return Promise.resolve(res.data)
  })
}

// 保存计划
export function savePutOn (params) {
  let loadingInstance = Loading.service({
    text: '数据保存中,请稍后...'
  })
  return axios.post(`/IAD_PutOnAPI/SavePutOnAPI?_t=${new Date().getTime()}`, qs.stringify(params)).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

// 自定义投放形式
export function savePutOnType (params) {
  return axios.post(`/IAD_AdsManage/SavePutOnType?_t=${new Date().getTime()}`, qs.stringify(params)).then(res => {
    return Promise.resolve(res.data)
  })
}

// 自定义投放形式
export function userDefined (params) {
  return axios.post(`/IAD_AdsManage/UserDefined?_t=${new Date().getTime()}`, qs.stringify(params)).then(res => {
    return Promise.resolve(res.data)
  })
}

// 上传素材
export function uploadMateriaImg (params, config) {
  let loadingInstance = Loading.service({
    text: '上传中,请稍后...'
  })
  return axios.post(`/IAD_PutOnAPI/UploadMateriaImg?_t=${new Date().getTime()}`, params, config).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  })
}




// WEBPACK FOOTER //
// ./src/api/mediaChecking.js